import React from 'react';
import cx from 'classnames';
import CheckIcon from '@mui/icons-material/CheckRounded';
import { timeLineFormatTime } from '../../../helpers';
import { clipLabel, CommentClip } from './clipComments';
import styles from './VideoComments.module.scss';

export const ClipCommentHeader = ({ clip, selected, atPlayhead, playing, onJump, onToggle }: {
  clip: CommentClip; selected: boolean; atPlayhead: boolean; playing: boolean;
  onJump: () => void; onToggle: () => void;
}) => <div className={cx(styles.clipHeader, styles.commentClipHeader, selected && styles.selectedHeader, atPlayhead && styles.playingHeader)}
  onKeyDown={(event) => event.stopPropagation()}>
  <button type="button" className={styles.clipJump} onClick={onJump} aria-label={`Jump to ${clipLabel(clip)}`}>
    <span className={styles.clipName}>{clipLabel(clip)}</span>
    <span className={styles.clipTime}>
      {atPlayhead && playing && <span className={styles.playingBars} aria-label="Playing"><i /><i /><i /></span>}
      <span className={styles.jumpHint}>Jump to</span>{timeLineFormatTime(clip.time_start).trim()}
    </span>
  </button>
  <button type="button" className={styles.clipTick} aria-label={`${selected ? 'Deselect' : 'Select'} ${clipLabel(clip)}`}
    aria-pressed={selected} onClick={onToggle}><CheckIcon aria-hidden="true" /></button>
</div>;
